import { useParams } from 'react-router-dom'
import { ParameterEditor } from '../../../Components/ManageParameter/index'
const CreateUpdateParameter: React.FC = () => {
  const { id, ParameterPageType = 'create' } = useParams<{
    id: string
    ParameterPageType: 'create' | 'edit' | 'view'
  }>()

  return <ParameterEditor parameterid={id} parameterPageType={ParameterPageType} />
}

export default CreateUpdateParameter
